<template>
    <div class="about">
        <section class="distribution" id="distribution" ref="map" :style="{ height: 780 * mapScale + 'px' }">
            <div class="map" :style="{ transform: 'scale(' + mapScale + ')' }">
                <div class="position">
                    <div class="dot"></div>
                    <p>{{ lang("qingdao") }}</p>
                    <div class="dir">
                        <div class="line"></div>
                        <router-link to="/subsidiary/characteristic/3" class="detail">
                            <img src="../assets/images/about/icon.png" alt="">
                            <div>{{ lang("qingdao_xjl") }}</div>
                        </router-link>
                    </div>
                </div>
                <div class="position">
                    <div class="dot"></div>
                    <p>{{ lang("hubei") }}</p>
                    <div class="dir">
                        <div class="line"></div>
                        <router-link to="/subsidiary/characteristic/7" class="detail">
                            <img src="../assets/images/about/icon.png" alt="">
                            <div>{{ lang("hubei_xjl") }}</div>
                        </router-link>
                    </div>
                </div>
                <div class="position">
                    <div class="dot"></div>
                    <p>{{ lang("shenzhen") }}</p>
                    <div class="dir">
                        <div class="line"></div>
                        <router-link to="/subsidiary/characteristic/4" class="detail">
                            <img src="../assets/images/about/icon.png" alt="">
                            <div>{{ lang("shenzhen_xjl") }}</div>
                        </router-link>
                    </div>
                </div>
                <div class="position">
                    <div class="dot"></div>
                    <p>{{ lang("xian") }}</p>
                    <div class="dir">
                        <div class="line"></div>
                        <router-link to="/subsidiary/characteristic/6" class="detail">
                            <img src="../assets/images/about/icon.png" alt="">
                            <div>{{ lang("xian_xjl") }}</div>
                        </router-link>
                    </div>
                </div>
                <div class="position">
                    <div class="dot"></div>
                    <p>{{ lang("guizhou") }}</p>
                    <div class="dir">
                        <div class="line"></div>
                        <router-link to="/subsidiary/characteristic/5" class="detail">
                            <img src="../assets/images/about/icon.png" alt="">
                            <div>{{ lang("guizhou_xjl") }}</div>
                        </router-link>
                    </div>
                </div>
                <div class="position">
                    <p>{{ lang("guangzhou") }}</p>
                    <div class="dot"></div>
                    <div class="dir">
                        <div class="line"></div>
                        <router-link to="/subsidiary/characteristic/2" class="detail">
                            <img src="../assets/images/about/icon.png" alt="">
                            <div>{{ lang("guangzhou_xjl") }}</div>
                        </router-link>
                    </div>
                </div>
                <div class="position">
                    <p class="position_title">{{ lang("dongguan") }}</p>
                    <div class="dot"></div>
                    <div class="dir">
                        <div class="line"></div>
                        <router-link to="/subsidiary/characteristic/2" class="detail">
                            <img src="../assets/images/about/icon.png" alt="">
                            <div>{{ lang("dongguan_xjl") }}</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>

        <div class="idea" id="idea">
            <img :src="idea.groupPicture" alt="">
            <div class="context">
                <div class="title">
                    <h3>
                        <div class="title1">
                            <div>集团理念</div>
                            <div class="subtitle">Group philosophy</div>
                        </div>
                        <span class="triangle"></span>
                    </h3>
                </div>
                <div class="ident"><span></span><span></span></div>
                <div class="phil" v-html="idea.groupIntroduce">

                </div>
            </div>
        </div>

        <div class="honor" id="honor">
            <div class="title">
                <h3>
                    <div class="title1">
                        <div>荣誉资质</div>
                        <div class="subtitle">Honorary qualification</div>
                    </div>
                    <span class="triangle"></span>
                </h3>
            </div>
            <div v-if="honorList.length > 0">
                <div class="content">
                    <div style="margin:0 auto;">
                        <img :src="honorImg" class="honorImg">
                    </div>
                    <div class="honorList">
                        <div class="list-contain">
                            <div class="time">
                                <div v-for="(item, index) in honorList" :class="{ active: index == current }">{{
                                    Object.keys(item)[0] }}<span></span><span></span><span></span></div>
                            </div>
                        </div>

                        <div class="honorDetial" @scroll="scrollEvent">
                            <div class="item" v-for="(item, index) in honorList">
                                <div v-for="(sitem, index1) in item[Object.keys(item)[0]]"
                                  :class="{ active: index == listx && index1 == listy }"
                                  @click="getCur(index, index1, sitem)">{{ sitem.honorName }}</div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="empty">
                暂无数据
            </div>
        </div>

        <div class="history" id="history">
            <div class="title">
                <h3>
                    <div class="title1">
                        <div>发展历程</div>
                        <div class="subtitle">development history</div>
                    </div>
                    <span class="triangle"></span>
                </h3>
            </div>
            <div class="context" ref="history" :style="{ height: 1318 * historyScale + 'px' }">
                <div class="process-parent" :style="{ transform: 'scale(' + historyScale + ')' }">
                    <div class="process">
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <img src="../assets/images/about/2001.jpg" alt="">
                                <div>
                                    <span>2001</span>
                                    <span>{{ lang("shenzhen_xjl") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <img src="../assets/images/about/2004.jpg" alt="">
                                <div>
                                    <span>2004</span>
                                    <span>{{ lang("qingdao_xjl") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <img src="../assets/images/about/2007.jpg" alt="">
                                <div>
                                    <span>2007</span>
                                    <span>{{ lang("guangzhou_xjl") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <!-- 原本有 8 个，删掉一个后，需要重新修改 css；由于没修改 css，直接留一个坑占位 -->
                        </div>
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <img src="../assets/images/about/2012.jpg" alt="">
                                <div>
                                    <span>2011</span>
                                    <span>{{ lang("guizhou_xjl") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <img src="../assets/images/about/2016.jpg" alt="">
                                <div>
                                    <span>2015</span>
                                    <span>{{ lang("xian_xjl") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <img src="../assets/images/about/2017.jpg" alt="">
                                <div>
                                    <span>2017</span>
                                    <span>{{ lang("hubei_xjl") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <span>2017</span>
                                <span>{{ lang("shanghai_xjl") }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <b></b>
                            <div class="text">
                                <span>2020</span>
                                <span>{{ lang("dongguan_xjl") }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
@red: #E60012;
@activeColor: #E60012;

.title {
    width: 1200px;

    h3 {
        text-align: left;
        margin: 0 0 20px 0;
        font-size: 20px;
        font-weight: 400;
        background: url(../assets/images/nav/logo_bg.png) no-repeat left center;
        padding-left: 9px;

        .subtitle {
            font-size: 16px;
            font-family: Roboto;
            font-weight: 900;
            color: #888888;
        }

        .title1 {
            width: 198px;
            display: inline-block;
        }

        .triangle {
            display: inline-block;
            border: 5px solid transparent;
            border-bottom: 5px solid @activeColor;
            border-right: 5px solid @activeColor;

        }
    }
}

.about {
    background: url(../assets/images/about/bg.png) right top no-repeat;
}

section {
    &.distribution {
        .map {
            position: relative;
            height: 780px;
            background: url(../assets/images/about/map.png) left top no-repeat;
            margin: 0 auto 98px auto;
            width: 1400px;
            overflow: hidden;

            .position {
                position: absolute;
                display: flex;
                align-items: center;
                color: @red;
                font-size: 18px;
                font-weight: bold;
                width: 100%;

                .dir {
                    display: flex;
                    position: absolute;
                    left: 42px;
                    bottom: 10px;
                    width: 100%;

                    .line {
                        width: calc(50% - 651px);
                        height: 121px;
                        border-left: 1px solid @red;
                        border-top: 1px solid @red;
                        transform: skew(-15deg);
                    }

                    .detail {
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        font-weight: 400;
                        color: #353535;
                        position: absolute;
                        top: -23px;
                        left: calc(50% - 633px);
                        cursor: pointer;

                        img {
                            width: 46px;
                            height: 46px;
                            margin-right: 10px;
                            object-fit: contain;
                        }
                    }
                }


                p {
                    margin: 0;
                }

                .dot {
                    width: 18px;
                    height: 18px;
                    background-color: @red;
                    border-radius: 50%;
                    position: relative;
                    margin: 0 18px;

                    &:after,
                    &:before {
                        content: "";
                        display: block;
                        width: 300%;
                        height: 300%;
                        position: absolute;
                        top: -100%;
                        left: -100%;
                        background-color: @red;
                        opacity: .5;
                        border-radius: 50%;
                        transform: scale(.33);
                    }

                    &:before {
                        animation: flash 1s linear infinite;
                    }

                    &:after {
                        animation: flash 1s .5s linear infinite;
                    }
                }

                &:nth-child(1) {
                    left: 675px;
                    top: calc(50% - 116px);
                }

                &:nth-child(2) {
                    left: 482px;
                    top: calc(50% + 82px);

                    .dir {
                        left: 35px;

                        .line {
                            width: calc(50% - 253px);
                            height: 76px;
                        }

                        .detail {
                            left: calc(50% - 246px);
                        }
                    }
                }

                &:nth-child(3) {
                    left: 595px;
                    top: calc(50% + 257px);

                    .dir {
                        left: 38px;
                        bottom: -84px;

                        .line {
                            width: calc(50% - 565px);
                            height: 97px;
                            border-left: 1px solid @red;
                            border-bottom: 1px solid @red;
                            border-top: none;
                            transform: skew(15deg);
                        }

                        .detail {
                            top: 74px;
                            right: -311px;
                            left: calc(50% - 550px);
                        }
                    }
                }

                &:nth-child(4) {
                    // flex-direction: row-reverse;
                    left: 431px;
                    top: calc(50% - 69px);

                    .dir {
                        left: 31px;
                        bottom: 17px;

                        .line {
                            width: calc(50% - 304px);
                            height: 27px;
                        }

                        .detail {
                            top: -22px;
                            right: -285px;
                            left: calc(50% - 299px);
                        }
                    }
                }

                &:nth-child(5) {
                    // flex-direction: row-reverse;
                    left: 403px;
                    top: calc(50% + 160px);

                    .dir {
                        left: 35px;
                        bottom: 17px;

                        .line {
                            width: calc(50% - 223px);
                            height: 54px;
                        }

                        .detail {
                            top: -22px;
                            right: -239px;
                            left: calc(50% - 216px);
                        }
                    }
                }

                &:nth-child(6) {
                    // flex-direction: row-reverse;
                    left: 527px;
                    top: calc(50% + 252px);

                    .dir {
                        left: 75px;
                        bottom: 17px;

                        .line {
                            width: calc(50% - 429px);
                            height: 82px;
                        }

                        .detail {
                            top: -22px;
                            right: -256px;
                            left: calc(50% - 422px);
                        }
                    }
                }

                &:nth-child(7) {

                    &>p.position_title {
                        position: relative;
                        left: 36px;
                        bottom: -23px;
                    }

                    left: 544px;
                    top: calc(50% + 256px);

                    .dir {
                        left: 66px;
                        bottom: 10px;

                        .line {
                            width: calc(50% - 439px);
                            height: 25px;
                        }

                        .detail {
                            top: -22px;
                            right: -311px;
                            left: calc(50% - 434px);
                        }
                    }
                }

                &:nth-child(8) {
                    left: 595px;
                    top: calc(50% + 257px);

                    .dir {
                        left: 34px;
                        bottom: -56px;

                        .line {
                            width: calc(50% - 477px);
                            height: 42px;
                            border-left: 1px solid @red;
                            border-bottom: 1px solid @red;
                            border-top: none;
                            transform: skew(20deg);
                        }

                        .detail {
                            top: 18px;
                            right: -311px;
                            left: calc(50% - 469px);
                        }
                    }
                }
            }
        }
    }
}

.honor {
    width: 1200px;
    margin: 0 auto;
    height: 509px;

    .content {
        width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 13px;

        img {
            max-width: 470px;
            max-height: 441px;
            object-fit: cover;
        }

        ;

        .honorList {
            display: flex;

            .list-contain {
                width: 38px;
                overflow: hidden;
            }

            .time {
                height: 441px;
                width: 48px;
                overflow: auto;

                &::-webkit-scrollbar {
                    display: none;
                }

                div {
                    color: #888888;
                    font-size: 14px;
                    line-height: 30px;
                    font-weight: 400;
                    position: relative;

                    &.active {
                        color: @red;
                        font-weight: bold;
                    }

                    &:not(:last-child) {
                        span {
                            display: none;
                            background-color: #D2D2D2;
                            width: 6px;
                            height: 14px;
                            margin-bottom: 10px;
                            position: relative;
                            left: 16px;

                            &:first-child {
                                height: 24px;
                            }

                            &:last-child {
                                height: 10px;
                                margin-bottom: 0;
                                display: block;
                            }
                        }

                        &.active {
                            span {
                                display: block;
                            }
                        }

                    }
                }
            }

            .honorDetial {
                height: 441px;
                overflow: auto;
                border-left: 1px solid #D2D2D2;
                padding-left: 21px;
                margin-left: 27px;
                font-size: 14px;
                line-height: 24px;

                .item {
                    div {
                        padding: 0 9px;
                        width: 450px;
                        text-align: left;
                        cursor: pointer;

                        &.active {
                            background-color: @red;
                            color: #FFFFFF;
                        }
                    }
                }

            }
        }

    }

    .empty {
        color: #888;
        line-height: 461px;
    }
}

.idea {
    display: flex;
    position: relative;
    max-width: 1400px;
    margin: 50px auto 98px auto;
    height: 598px;

    img {
        display: inline-block;
        width: 1020px;
        height: 554px;
        object-fit: cover;
        position: absolute;
    }

    .context {
        position: absolute;
        right: 0;
        top: 137px;
        width: 1100px;
        background-color: #EFEFEF;
        padding: 36px 33px;
        font-size: 14px;
        color: #353535;

        .ident {
            display: flex;
            position: absolute;
            top: 98px;
            left: 34px;

            span {
                width: 48px;
                height: 4px;
                background-color: #353535;

                &:not(:last-child) {
                    background-color: @activeColor;
                }

            }
        }

        .phil {
            width: 705px;
            margin-top: 25px;
            text-align: left;
            // line-height: 24px;
        }
    }
}

.history {
    .title {
        width: 1200px;
        margin: 55px auto 0;
    }

    .context {
        // width: 1200px;
        // margin: 55px auto 0;
        height: 1318px;
        min-width: 1407px;
        padding-top: 178px;
        background: url("../assets/images/about/licheng_bg.png");
        background-size: cover;

        .process {
            width: 1407px;
            height: 1031px;
            margin: 55px auto 0;
            background: url("../assets/images/about/quxian.png") no-repeat center;
            margin: 0 auto;
            position: relative;

            .item {
                position: absolute;

                b {
                    position: absolute;
                    width: 59px;
                    height: 59px;
                    background: url(../assets/images/about/tuoyuan.png) no-repeat;
                }

                .text {
                    width: 413px;
                    height: 124px;
                    position: absolute;
                    text-align: center;

                    span {
                        display: block;
                        font-size: 16px;
                        color: #333;
                        margin-top: 5px;

                        &:first-child {
                            font-size: 26px;
                            margin-top: 0;
                        }
                    }

                    img {
                        width: 176px;
                        height: 109px;
                        border-radius: 5px;
                        flex-shrink: 0;
                    }
                }

                &:nth-child(1) {
                    left: 200px;

                    b {
                        top: -20px;
                        left: 0;
                    }

                    .text {
                        width: 421px;
                        height: 115px;
                        display: flex;
                        padding: 3px 0 0 12px;
                        background: url(../assets/images/about/2001.png) no-repeat;
                        top: -100px;
                        left: 100px;

                        div {
                            padding: 15px;
                        }
                    }
                }

                &:nth-child(2) {
                    left: 398px;
                    top: 10px;

                    b {
                        top: 0px;
                        left: 0;
                    }

                    .text {
                        background: url(../assets/images/about/2004.png) no-repeat;
                        top: 60px;
                        left: -335px;
                        display: flex;
                        padding: 12px 0 0 3px;

                        div {
                            padding: 17px;
                        }
                    }
                }

                &:nth-child(3) {
                    right: 799px;
                    top: 79px;

                    b {
                        top: -20px;
                        left: 0;
                    }

                    .text {
                        width: 421px;
                        height: 115px;
                        background: url(../assets/images/about/2001.png) no-repeat;
                        top: -100px;
                        left: 100px;
                        display: flex;
                        padding: 3px 0 0 12px;

                        div {
                            padding: 17px;
                        }
                    }
                }

                &:nth-child(4) {
                    right: 609px;
                    top: 100px;

                    b {
                        top: 0px;
                        left: 0;
                    }

                    .text {
                        background: url(../assets/images/about/support_hhx.png) no-repeat;
                        top: 70px;
                        right: -100px;
                        padding: 23px 12px 0px 195px;
                    }
                }

                &:nth-child(5) {
                    right: 149px;
                    top: 148px;

                    b {
                        top: 0px;
                        right: 212px;

                    }

                    .text {
                        background: url(../assets/images/about/2012.png) no-repeat;
                        top: 70px;
                        right: -130px;
                        display: flex;
                        padding: 11px 0 0 3px;

                        div {
                            padding: 17px;
                        }
                    }
                }

                &:nth-child(6) {
                    left: 1276px;
                    bottom: 563px;

                    b {
                        top: -20px;
                        right: 92px;

                    }

                    .text {
                        background: url(../assets/images/about/2016.png) no-repeat;
                        top: 70px;
                        right: -130px;
                        display: flex;
                        padding: 12px 0 0 3px;

                        div {
                            padding: 17px;
                        }
                    }
                }

                &:nth-child(7) {
                    left: 861px;
                    bottom: 537px;

                    b {
                        top: 0px;
                        right: 212px;

                    }

                    .text {
                        width: 447px;
                        height: 115px;
                        background: url(../assets/images/about/2017.png) no-repeat;
                        top: -80px;
                        left: -180px;
                        display: flex;
                        padding: 3px 0 0 12px;

                        div {
                            padding: 17px;
                        }
                    }
                }

                &:nth-child(8) {
                    left: 206px;
                    bottom: 595px;

                    b {
                        top: 88px;
                        right: -194px;

                    }

                    .text {
                        width: 455px;
                        height: 142px;
                        background: url(../assets/images/about/support_shagnhai.png) no-repeat;
                        top: 60px;
                        right: -130px;
                        padding: 15px 0 0 197px;

                        span {
                            width: 225px;
                        }
                    }
                }

                &:nth-child(9) {
                    left: 247px;
                    bottom: 300px;

                    b {
                        top: 0px;
                        right: 212px;

                    }

                    .text {
                        width: 447px;
                        height: 115px;
                        background: url(../assets/images/about/2020.png) no-repeat;
                        top: -80px;
                        left: -180px;
                        padding: 21px 0 0 191px;
                    }
                }
            }


        }
    }
}

@media screen and (max-width: 1360px) {
    #distribution {
        width: 100%;
        height: 780px;
        overflow: hidden;

        .map {
            width: 1300px;
            height: 780px;
            transform-origin: left top;
        }
    }

    #idea {
        position: relative;
        width: 100%;
        height: auto;
        padding: 20px;
        box-sizing: border-box;
        margin-bottom: 30px;

        img {
            width: 100%;
            height: auto;
            position: static;
        }

        .context {
            position: absolute;
            left: 40px;
            top: 40px;
            right: 40px;
            bottom: 40px;
            padding: 20px;
            width: auto;
            height: auto;
            opacity: .8;
            overflow: auto;

            .ident {
                top: 70px;
                left: 20px;
            }

            .phil {
                width: auto;
            }

            .title {
                width: 100%;

                h3 {
                    padding-left: 0;
                }
            }
        }
    }

    #honor {
        width: auto;
        height: auto;
        padding: 15px;

        .title {
            width: auto;
        }

        .content {
            flex-direction: column;
            width: auto;

            img {
                width: 100%;
                max-width: unset;
                height: auto;

            }

            .honorList {
                width: auto;
                align-self: stretch;
                display: flex;
                padding: 20px;

                .honorDetial {
                    flex: auto;

                    .item div {
                        width: auto;
                        padding: 5px 10px;
                    }
                }
            }

            .list-contain {
                width: 60px;

                .time {
                    width: 100%;
                }
            }
        }
    }

    #history {
        overflow: hidden;

        .title {
            margin-top: 15px;
            padding: 15px;
        }

        .context {
            width: 100%;
            height: 1318px;
            overflow: hidden;
            padding-top: 0;

            .process-parent {
                padding-top: 178px;
                width: 1720px;
                height: 1318px;
                transform-origin: left top;

                .item .text span {
                    font-size: 26px;

                    &:nth-child(2) {
                        margin-top: 5px;
                    }
                }
            }

            .process .item {
                .text {
                    padding-top: 5px;

                    div {
                        padding: 3px 8px;
                    }
                }
            }

            .process .item:nth-child(4) .text {
                padding-top: 10px !important;
            }

            .process .item:nth-child(7) .text {
                img {
                    width: 200px;
                }

                div {
                    padding-top: 0;
                }
            }
        }
    }
}
</style>
<script>
export default {
    data() {
        return {
            listx: 0,
            listy: 0,
            idea: {},
            honorList: [],
            honorImg: '',
            toggeleSrc: true,
            current: 0,
            mapScale: 1,
            historyScale: 1
        }
    },
    mounted() {
        this.getIdea();
        this.getHonor();
        this.mapScale = Math.min(this.$refs.map.offsetWidth / 1300, 1);
        this.historyScale = Math.min(this.$refs.map.offsetWidth / 1720, 1);
        window.onresize = () => {
            this.mapScale = Math.min(this.$refs.map.offsetWidth / 1300, 1);
            this.historyScale = Math.min(this.$refs.map.offsetWidth / 1720, 1);
        }
    },
    computed: {
        id() {
            return this.$route.params.id
        }
    },
    methods: {
        getCur(x, y, item) {
            let that = this;
            if (that.listx == x && that.listy == y || !that.toggeleSrc) return;
            that.toggeleSrc = false;
            that.listx = x;
            that.current = x;
            that.listy = y;
            $(".honorImg").animate(
                { opacity: 'toggle' },
                "normal",
                null,
                function () {
                    $(".honorImg").attr("src", item.profuctPicture);
                    $(".honorImg").animate({ opacity: 'toggle' }, "normal");
                    setTimeout(() => {
                        that.toggeleSrc = true
                    }, 300)
                }
            );
            // this.honorImg = item.profuctPicture
        },
        scrollEvent() {
            let currentHeight = 0, nextHeight = $('.honorDetial .item')[0].offsetHeight;
            for (let i = 0; i < $('.honorDetial .item').length; i++) {
                if ($('.honorDetial')[0].scrollTop > currentHeight && $('.honorDetial')[0].scrollTop < nextHeight) {
                    this.current = i;
                }
                currentHeight = currentHeight + $('.honorDetial .item')[i].offsetHeight;
                if ($('.honorDetial .item')[i + 1]) {
                    nextHeight = nextHeight + $('.honorDetial .item')[i + 1].offsetHeight;
                }

            }


        },
        getIdea() {
            var that = this;
            let language = that.$root.langMode == 0 ? "CN" : "EN"
            ajax.call(this, {
                url: "/bloc/groupIdea/list/" + language,
                data: {},
                s(res) {
                    that.idea = res.data
                }
            });
        },
        getHonor() {
            var that = this;
            ajax.call(this, {
                url: "/bloc/honorInfo/list/language",
                data: {
                    companyId: 1
                },
                s(res) {
                    that.honorList = res.data;
                    if (res.data.length > 0) {
                        let current = res.data[0]
                        that.honorImg = current[Object.keys(current)[0]][0].profuctPicture
                    }


                }
            });
        }
    },
    watch: {
        "$root.language"() {
            this.getIdea();
            this.getHonor();
        },
        id: {
            handler(newVal) {
                this.$nextTick(() => {
                    switch (newVal) {
                        case "1":
                            $(window).scrollTop($("#distribution").offset().top - 100);
                            break;
                        case "2":
                            $(window).scrollTop($("#idea").offset().top - 100);
                            break;
                        case "3":
                            $(window).scrollTop($("#honor").offset().top - 100);
                            break;
                        case "4":
                            $(window).scrollTop($("#history").offset().top - 100);
                            break;
                    }
                })
            },
            immediate: true
        }
    }
}
</script>
